import { TabbedPanel } from '@/scenes.ui/tabbed-panel';
import PlayerStore from '@/store/player';
import ShopStore from '@/store/shop';
import { injectable } from 'inversify';
import { Scene } from 'phaser';
import { IapService } from './iap-service';
import { ListService } from './list-service';
import { PaymentChangeService } from './payment-change-service';
import { PaymentNotificationService } from './payment-notification-service';
import { ShopService, TabName } from './shop-service';
import Container = Phaser.GameObjects.Container;
import { Tr } from '@/i18n/i18n';
import { Fonts } from '@/constants/font';
import { StringUtils } from '@/utils/string-utils';
import { Profile } from '@/store/profile/types';
import { SaleIntroPanel } from '@/scenes.ui/sale-intro-panel';
import { GiftGemsAgitationPanel } from '@/scenes.ui/gift-gems-agitation-panel';
import {TextPanel} from "@/scenes.ui/text-panel";

@injectable()
export class GiftGemsShopService extends ShopService {

    private receiver: Profile | undefined;

    public openGiftPurchases(scene: Scene, canvas: HTMLCanvasElement, noValuteFeedback: boolean, closeCallback: () => void,
                     paymentNotificationService: PaymentNotificationService, statClickCallback: (creatureId: string) => unknown,
                     tabName: TabName, listService: ListService, paymentChangeService: PaymentChangeService,
                     iapService: IapService, receiver: Profile) {
        this.receiver = receiver;
        this.openShop(scene, canvas, noValuteFeedback, closeCallback,
            paymentNotificationService, statClickCallback, tabName, listService, paymentChangeService, iapService);
    }

    protected createTabbedPanel(): TabbedPanel {
        return new TabbedPanel(this.scene!, this.canvas!, '', ['gift'],
            [Tr('gift.gems')], [true], this.selectSound, (tabId: string) => this.populateGiftList(), () => {}, () => this.closeCallback());
    }

    private populateGiftList(): void {
        this.setPanelTitle();
        let self = this;
        ShopStore.fetchGiftPurchaseOptions().then(options => {
            const panels: Container[] = [];

            if (this.receiver) {
                ShopStore.reserveGiftPurchase(this.receiver.id).then(() => {
                    panels.push(new GiftGemsAgitationPanel(this.scene!, this.receiver!.displayingName));
                    this.showBankOptions(options, panels, PlayerStore.getPlayer(), false, true, false);
                    panels.push(new TextPanel(self.scene!, Tr('g.p.w'), 'center'));
                    this.tabbedPanel.supplyChildren('gift', panels);
                });
            }
        });
    
    }

    private setPanelTitle() {
        if (this.receiver) {
            this.tabbedPanel.setTitle(Tr('gft'));
            this.tabbedPanel.setAgitationText(StringUtils.formatString(Tr('make.a.special.gift'), this.receiver.displayingName));
        }
    }

}